import * as h2Api from '../h2Api'

export const REFER_EDUCATOR = 'EDUCATOR_ACCOUNT_REFERRAL'

export const requestReferral = form => dispatch => {
  return dispatch(
    h2Api.post('/user/request/educatorreferral', form)({ type: REFER_EDUCATOR })
  )
}
